<template>
  <div data-cy="filterOverrideBar">
    <v-btn
      :key="index"
      @click="toggleValue(override)"
      class="ml-2"
      :data-cy="`filterOverrideButton-${override.name}`.replace(/ /g, '-')"
      :data-test="`filterOverrideButton-${override.name}`.replace(/ /g, '-')"
      elevation="0"
      small
      v-for="(override, index) in presetOverrideList"
    >
      <v-icon class="mr-1" color="primary" small v-if="isSelected(override)">far fa-fw fa-check-square</v-icon>
      <v-icon class="mr-1" color="grey darken-1" small v-else>far fa-fw fa-square</v-icon>
      {{ override.name }}
    </v-btn>
  </div>
</template>

<script>
import { intersectionWith, isEqual } from "lodash";
export default {
  computed: {
    filterOverrideList() {
      return this.userConfig.filterOverrideList;
    },
    userConfig() {
      return this.$store.state.session.user.userConfiguration;
    },
  },
  async created() {
    if (this.userConfig.filterOverrideList === undefined) {
      await this.saveDefaultFilterOverrideList();
    }
  },
  data() {
    return {
      presetOverrideList: [
        {
          name: "Hide FYI",
          filterList: [
            {
              attributeName: "operationalizeType",
              attributeNameLabel: "Operationalize Type",
              operator: "notIn",
              operatorLabel: "!=",
              value: ["FYI"],
              valueLabel: "FYI",
            },
          ],
        },
        {
          name: "Hide Not Impacted",
          filterList: [
            {
              attributeName: "memberTestPlan.status",
              attributeNameLabel: "Testing/Review Status",
              operator: "notIn",
              operatorLabel: "!=",
              value: ["Not Impacted", "Historically Not Impacted"],
              valueLabel: "Not Impacted",
            },
          ],
        },
      ],
    };
  },
  methods: {
    isSelected(preset) {
      const filtersInCommon = intersectionWith(this.filterOverrideList, preset.filterList, isEqual);
      if (filtersInCommon.length === preset.filterList.length) {
        return true;
      }
      return false;
    },
    async saveDefaultFilterOverrideList() {
      const filterOverrideList = this.presetOverrideList.reduce((acc, override) => {
        return [...acc, ...override.filterList];
      }, []);
      await this.updateFilterOverrideList(filterOverrideList);
    },
    async toggleValue(preset) {
      if (this.isSelected(preset)) {
        const filterOverrideList = this.filterOverrideList.filter(filter => {
          return !intersectionWith([filter], preset.filterList, isEqual).length;
        });
        await this.updateFilterOverrideList(filterOverrideList);
        this.$emit("refreshList");
        return;
      }
      const filterOverrideList = [...this.filterOverrideList, ...preset.filterList];
      await this.updateFilterOverrideList(filterOverrideList);
      this.$emit("refreshList");
    },
    async updateFilterOverrideList(filterOverrideList) {
      const userConfig = Object.assign({}, this.userConfig, { filterOverrideList });
      await this.$store.dispatch("session/updateUserConfiguration", userConfig);
      this.$emit("refreshList");
    },
  },
};
</script>

<style></style>
